"use client";

import { useQuestCompletions } from "@/components/QuestsV2/useQuestCompletions";
import { type ReactNode, createContext, useContext } from "react";
import type { GameData } from "../app/games/(details)/types";
import { useGameDetails } from "../app/games/(details)/useGameDetails";

type GameDetailsContextValue = ReturnType<typeof useGameDetails>;

const GameDetailsContext = createContext<GameDetailsContextValue | undefined>(
  undefined,
);

interface GameDetailsProviderProps {
  gameData: GameData;
  children: ReactNode;
}

export const GameDetailsProvider = ({
  gameData,
  children,
}: GameDetailsProviderProps) => {
  const { completedQuests, mutate: invalidateQuestCompletions } =
    useQuestCompletions(gameData.details.game_id);

  const gameDetailsValue = useGameDetails(
    gameData,
    Object.values(completedQuests ?? {}),
    invalidateQuestCompletions,
  );

  return (
    <GameDetailsContext.Provider value={gameDetailsValue}>
      {children}
    </GameDetailsContext.Provider>
  );
};

export const useGameDetailsContext = () => {
  const context = useContext(GameDetailsContext);
  if (context === undefined) {
    throw new Error(
      "useGameDetailsContext must be used within a GameDetailsProvider",
    );
  }
  return context;
};
